import { faMegaphone, faTimes } from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useContext, useEffect, useState } from 'react'
import * as SETTINGS from '../../../constants/settings'
import { SiteConfigContext } from '../../../context/siteConfigContext'
import 'video.js/dist/video-js.css'
import { toastError, toastSuccess } from '../../../utils/toast'
import './vjs-moal.css'

const HighlightedPM = ({ onHistory = false }) => {
  const [showHighlight, setShowHighlight] = useState(true)
  const { [SETTINGS.HIGHLIGHTED_MESSAGE.key]: highlightedMessage } =
    useContext(SiteConfigContext)
  const { updateSetting } = useContext(SiteConfigContext)

  const handleUnHighlight = async () => {
    const response = await updateSetting(SETTINGS.HIGHLIGHTED_MESSAGE, null)

    if (response.data?.setting === SETTINGS.HIGHLIGHTED_MESSAGE.key) {
      toastSuccess('Message highlight removed.')
    } else {
      toastError('Failed to remove highlight.')
    }
  }

  const handleShowHighlight = () => {
    setShowHighlight((prev) => !prev)
  }

  if (!(highlightedMessage && highlightedMessage.message)) {
    return null
  }

  if (onHistory) {
    return (
      <div className="flex flex-col gap-4 border border-neutral-300 dark:border-neutral-700 bg-neutral-100 dark:bg-neutral-900 w-fit p-3 rounded mr-auto">
        <h3>Current Highlight</h3>
        <div className="relative w-fit flex flex-col gap-2 overflow-visible animate-highlightedPM">
          <div className="p-3 bg-blue-800 highlighted-glow rounded-xl shadow-highlightedPM shadow-blue-500">
            <p className="flex flex-col gap-1">
              <span className="text-xs">
                <strong
                  className={`mr-auto text-${highlightedMessage.user.userService.profile.color} bg-blue-900 px-1.5 py-0.5 rounded-md`}
                >
                  {highlightedMessage.user.userService.profile.name}
                </strong>
              </span>
              <strong className="text-sm text-white">
                {highlightedMessage.message}
              </strong>
            </p>
          </div>
          <button
            className="absolute top-1.5 right-1.5 rounded-full size-6 flex items-center justify-center button-outline border-red-600 hover:border-red-400 text-red-600 hover:text-red-400 hover:shadow-none"
            onClick={handleUnHighlight}
          >
            <span className="sr-only">Remove Highlight</span>
            <FontAwesomeIcon icon={faTimes} />
          </button>
        </div>
      </div>
    )
  }

  return (
    <div className="absolute bottom-14 left-0 mx-2 z-[5] w-fit max-w-[75%] flex flex-col gap-2 overflow-visible animate-highlightedPM">
      <div className="flex gap-2 justify-start items-end">
        <div
          onClick={() => handleShowHighlight()}
          className="flex items-center justify-center p-2.5 size-fit bg-blue-800 rounded-full border border-blue-500"
        >
          <FontAwesomeIcon
            icon={faMegaphone}
            className="size-3 lg:size-5 text-white -rotate-[24deg]"
          />
        </div>

        <div
          className={`p-2.5 bg-blue-800 highlighted-glow rounded-xl border border-blue-500 ${showHighlight ? 'block' : 'hidden'}`}
        >
          <p className="flex flex-col gap-1 text-xs font-semibold">
            <span
              className={`mr-auto text-${highlightedMessage.user.userService.profile.color} bg-blue-900 px-1.5 py-0.5 rounded-md`}
            >
              {highlightedMessage.user.userService.profile.name}
            </span>
            <span className="text-white">{highlightedMessage.message}</span>
          </p>
        </div>
      </div>
    </div>
  )
}

export default HighlightedPM
